import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import { DataBR } from '@format';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { confirmarAlert } from 'app/services/alerts';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useEffect, useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';

const ContasPagarPagamentosRealizados = ({
  showCancelarBaixa = true,
  showTitle = true,
  showParcelas = true,
  parcelas,
  formik,
  baixas,
}) => {
  const [baixasState, setBaixasState] = useState([]);
  const [, setCancelarBaixas] = useState([]);

  const totalParcelas = parcelas?.length;

  useEffect(() => {
    if (parcelas !== undefined && showParcelas) {
      getBaixasParcelada(parcelas);
    } else if (baixas !== undefined) {
      getBaixasUnica(baixas);
    }
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parcelas]);

  function getBaixasParcelada(parcelas) {
    parcelas.forEach((parcela, index) => {
      if (parcela.baixas) {
        parcela.baixas.forEach((baixa) => {
          const baixaComOrigem = {
            ...baixa,
            parcelaIndex: index,
          };

          // Verificar se baixaComOrigem já está em baixaState
          setBaixasState((prev) => {
            const existe = prev.some(
              (b) => b.id === baixaComOrigem.id && b.parcelaIndex === baixaComOrigem.parcelaIndex
            );

            // Se não existe, adicionar
            if (!existe) {
              const atualizado = [...prev, baixaComOrigem];
              // Ordenar pelo campo dataPagamento
              return atualizado.sort((a, b) => new Date(a.dataPagamento) - new Date(b.dataPagamento));
            }

            // Senão, retornar o estado atual sem alterações
            return prev;
          });
        });
      }
    });
  }

  function getBaixasUnica(baixas) {
    baixas.forEach((baixa) => {
      setBaixasState((prev) => {
        const atualizado = [...prev, baixa];
        // Ordenar pelo campo dataPagamento
        return atualizado.sort((a, b) => new Date(a.dataPagamento) - new Date(b.dataPagamento));
      });
    });
  }

  const handleCancelarBaixa = (id) => () => {
    confirmarAlert({
      opcoes: {
        title: 'Tem certeza que deseja cancelar a baixa?',
      },
      confirmar: () => {
        // Atualiza a lista de cancelamento com o novo UUID
        setCancelarBaixas((prevCancelarBaixas) => {
          const updatedCancelarBaixas = [...prevCancelarBaixas, id];
          formik.setFieldValue('cancelarBaixas', updatedCancelarBaixas);
          return updatedCancelarBaixas;
        });

        // Atualiza a lista de baixas removendo o elemento com o id
        setBaixasState((prev) => prev.filter((item) => item.id !== id));
      },
    });
  };

  return (
    <>
      <Grid container>
        {showTitle && (
          <Grid item xs={12}>
            <FormTitle title="Pagamentos realizados" />
          </Grid>
        )}
        {baixasState?.map((baixa, index) => (
          <Grid container style={{ marginBottom: 10 }} xs={12}>
            <Grid item key={index} xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="dataPagamento"
                label="Data do pagamento"
                value={baixa?.dataPagamento ? DataBR(baixa?.dataPagamento) : '-'}
              />
            </Grid>
            <Grid item key={index} xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="dataLiquidacao"
                label="Data da liquidação"
                value={baixa?.dataLiquidacao ? DataBR(baixa?.dataLiquidacao) : '-'}
              />
            </Grid>
            <Grid item xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="valorPago"
                label="Valor Pago (R$)"
                value={baixa?.valorPago ? getCurrency(baixa?.valorPago).replace('R$', '') : '-'}
              />
            </Grid>
            {parcelas !== undefined && showParcelas && (
              <Grid item xs={showCancelarBaixa ? 2 : 4}>
                <TextLabel id="numeroParcela" label="Parcela" value={baixa.parcelaIndex + 1 + '/' + totalParcelas} />
              </Grid>
            )}
            {showCancelarBaixa && (
              <Grid
                item
                style={{ justifyContent: 'center', alignContent: 'center', marginLeft: 15 }}
                xs={showCancelarBaixa ? 2 : 4}
              >
                <Tooltip title="Cancelar baixa" placement="right-end">
                  <IconButton onClick={handleCancelarBaixa(baixa?.id)}>
                    <MdHighlightOff size={18} />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ContasPagarPagamentosRealizados;
